import { ComponentType, PropsWithChildren } from 'react';

import {
  Extension,
  attachComponentData,
  useElementFilter,
} from '@backstage/core-plugin-api';

export type ReportEditorDataExtensionOptions = {
  id: string;
  DataProvider: ComponentType<PropsWithChildren<{}>>;
};

const REPORT_EDITOR_DATA_EXTENSION_KEY =
  'confidence.report-editor-data-extension';

export const createReportEditorDataExtension = (
  options: ReportEditorDataExtensionOptions,
): Extension<() => null> => {
  return {
    expose() {
      const ReportEditorDataExtensionDataHolder = () => null;

      attachComponentData(
        ReportEditorDataExtensionDataHolder,
        REPORT_EDITOR_DATA_EXTENSION_KEY,
        options,
      );

      return ReportEditorDataExtensionDataHolder;
    },
  };
};

const reportEditorExtensionsStorage = new WeakMap<
  ComponentType,
  ReportEditorDataExtensionOptions[]
>();

export const ReportEditorDataExtensions: ComponentType<
  PropsWithChildren<{}>
> = ({ children }): JSX.Element | null => {
  const extensions = useElementFilter(children, elements =>
    elements.findComponentData<ReportEditorDataExtensionOptions>({
      key: REPORT_EDITOR_DATA_EXTENSION_KEY,
    }),
  );

  reportEditorExtensionsStorage.set(ReportEditorDataExtensions, extensions);

  return null;
};

export const useReportEditorDataExtensions =
  (): ReportEditorDataExtensionOptions[] => {
    return reportEditorExtensionsStorage.get(ReportEditorDataExtensions) || [];
  };
